import React, {useEffect, useState, useContext} from 'react';
import Swal from 'sweetalert2';
import ContactContext from '../../context/contact/contactContext';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [hasSubmitted, setHasSubmitted] = useState(false)

  const contactContext = useContext(ContactContext);

  const {submitForm, error, loading, clearError} = contactContext;

  useEffect(() => {
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
    if (error) {
      console.log(error)
    }

  }, []);

  useEffect(()=> {
    if (error?.isNetworkError) {
      Swal.fire({
        icon: 'info',
        text: 'Network Error, pls check your internet connection'
      })
    }
  }, [error])

  const onSubmit = async (e) => {
    e.preventDefault();
    // do checks
    if (name === "") {
      console.log('enter a name');
      await Swal.fire({
        icon: 'info',
        text: 'Please enter a name',
      })
    }
    if (name.length > 256) {
      console.log('Your name can\'t be greater than 256');
      await Swal.fire({
        icon: 'info',
        text: 'Your name can\'t be greater than 256',
      })
    }
    if (email === "") {
      console.log('enter an email');
      await Swal.fire({
        icon: 'info',
        text: 'This email field cannot be blank'
      })
    }
    let emailRegex = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$";
    if (!email.match(emailRegex)) {
      console.log('Enter a valid email');
      await Swal.fire({
        icon: 'info',
        text: 'Enter a valid email'
      })
    }
    if (message === "") {
      console.log('enter a message')
      console.log('This message should not be more than 500 characters');
      await Swal.fire({
        icon: 'info',
        text: 'This message field cannot be left blank'
      })
    }
    if (message.length > 500) {
      console.log('This message should not be more than 500 characters');
      await Swal.fire({
        icon: 'info',
        text: 'This message should not be more than 500 characters'
      })
    }
    setIsSubmitting(true);

    try {
      const data = {
        _type: 'form',
        name,
        email,
        message
      }

      submitForm(data);

      console.log('submitted')
      setIsSubmitting(false)
      setHasSubmitted(true)
    } catch (err) {
      console.error(err);
      await Swal.fire({
        icon: 'error',
        text: 'An error occurred, please try again'
      })
    }
    setTimeout(() => {
      setHasSubmitted(false)
    }, 3500)
  }

  return (
    <div className="container px-2 md:px-4 mt-10 mb-10 lg:w-9/12">
      <div className="px-1 md:px-12 mb-10">
        <h3 className="text-5xl mb-4">Let's Work</h3>
        <p className="text-2xl">Contact me through any of these:</p>
      </div>

      <div className="px-1 md:px-12 mt-5 flex flex-row flex-wrap justify-between">
        <a href="https://github.com/billmal071" target="_blank" rel="noreferrer noopener" className="mb-2">
          <i aria-label="github profile" className="fab fa-github fa-4x"> </i> <span
          className="self-start ml-2 text-lg">Billmal071</span>
        </a>
        <a href="https://www.linkedin.com/in/williams-malachy-224b22178/
" target="_blank" rel="noreferrer noopener" className="mb-2">
          <i className=" fab fa-linkedin-in fa-3x p-2 text-white bg-blue-500"> </i><span
          className="self-start ml-2 text-lg">Williams Malachy</span>
        </a>
        <a href="https://www.gmail.com" target="_blank" rel="noreferrer noopener"><i
          className="fas fa-envelope-square fa-4x text-red-400"> </i><span
          className="self-start ml-2 text-lg">billmal071@gmail.com</span></a>
      </div>

      <div className="mt-5">
        <div className="text-center">
          {isSubmitting && (
            <h3 className="text-2xl text-blue-400 uppercase p-3 rounded-3xl mx-2"
                style={{background: 'rgba(27,27,27,.91)'}}>
              <i className="fas fa-spinner animate-spin mr-3"> </i>submitting...
            </h3>
          )}
          {hasSubmitted && (
            <h3 className="text-2xl text-green-700 uppercase p-3 rounded-3xl mx-2 my-3"
                style={{background: 'rgba(27,27,27,.91)'}}>Submitted
            </h3>
          )}
        </div>

        <form action="" onSubmit={onSubmit} className="flex flex-col px-2 md:px-12">
          <label htmlFor="name" className="mb-3">Your Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            className="py-3 rounded-lg pl-2"
            style={{background: 'rgba(27,27,27,.91)'}}
            maxLength="256"
            required
            autoFocus={true}
          />
          <br/>
          <label htmlFor="email" className="mb-3">Your Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter you email"
            className="py-3 rounded-lg pl-2"
            style={{background: 'rgba(27,27,27,.91)'}}
            maxLength="256"
            required
          />
          <br/>
          <label htmlFor="message" className="mb-3">Your Message</label>
          <textarea
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            id="message"
            placeholder="Enter you email"
            className="py-3 rounded-lg pl-2"
            style={{background: 'rgba(27,27,27,.91)'}}
            cols="30"
            rows="5"
            maxLength="500"
            required
          >
          </textarea>
          <br/>
          <button className="bg-gray-900 rounded-lg inline py-2 text-gold font-bold">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
